import { namespace, Point } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractItem from './abstractItem';

namespace('Ofcs.Editor.Item');

/**
 * @class FigureItem
 * @extends AbstractItem
 */
export default window.Ofcs.Editor.Item.FigureItem = AbstractItem.extend({

    type: 'figure',

    defaults: {
        /**
         * @property {string} Type
         */
        type: 'CatalogObject',

        /**
         * Name of the item
         * @property {string} attributes.name
         */
        name: null,

        /**
         * @property {Number} Item ID
         */
        itemId: null,

        /**
         * Current position
         * @property {Point} attributes.position
         */
        position: new Point(0, 0),

        /**
         * Initial rotation
         * @property {Number} attributes.initialRotation
         */
        initialRotation: 0.00,

        /**
         * Current rotation
         * @property {Number} attributes.rotation
         */
        rotation: 0,

        /**
         * Extended path coordinates
         * @property {Array} attributes.ext
         */
        ext: [],

        /**
         * Original path coordinates
         * @property {Array} attributes.orig
         */
        orig: [],

        /**
         * Safety margin path coordinates
         * @property {Array} attributes.safety
         */
        safety: [],

        /**
         * Width of the shape
         * @property {Number} attributes.width
         */
        width: 0,

        /**
         * Height of the shape
         * @property {Number} attributes.height
         */
        height: 0,

        /**
         * Depth that the item sinks into the foam
         * @property {Number} attributes.depth
         */
        depth: 0,

        /**
         * Total depth of the item
         * @property {Number} attributes.totalDepth
         */
        totalDepth: 0,

        /**
         * Path to item image
         * @property {string} attributes.image
         */
        image: null,

        /**
         * Path to png mask of the item image
         * @property {string} attributes.mask
         */
        mask: null,

        /**
         * Allow flipping of figure.
         * @property {Boolean} attributes.allowFlipping
         */
        allowFlipping: false,

        /**
         * Is figure flipped?
         * @property {Boolean} attributes.flipped
         */
        flipped: false,
    },

    initialize() {
        AbstractItem.prototype.initialize.call(this);

        this.supportsRotation = true;
        this.supportsInitialRotation = true;
        this.supportsPositioning = true;
        this.supportsFlipping = true;
        this.supportsAlign = true;
        this.supportsVersions = true;
        this.supportsCollisions = true;
        this.supportsOutOfFoam = true;
        this.supportsGuides = true;
        this.supportsAvailability = true;
        this.supportsMaxHeight = true;
    },

    /**
     * Recalculate rotation, so that it is always within a range of 0 to 360
     * Returns 0 if value is not valid.
     * @param {number} value
     * @return {number}
     * @private
     */
    _recalculateRotation(value) {
        return (360 + value) % 360;
    },

    /**
     * Translate object into json stringable types. This method will be used
     * by JSON.stringify() automaticly.
     *
     * @return {Object}
     */
    toJSON(...args) {
        const attributes = AbstractItem.prototype.toJSON.apply(this, args);

        return {
            flipped: attributes.flipped,
            itemId: attributes.itemId,
            rotation: attributes.rotation,
            initialRotation: attributes.initialRotation,
            type: attributes.type,
            x: attributes.x,
            y: attributes.y,
        };
    },
});
